module.exports = __webpack_public_path__ + "img/qrcode-mengxuan.a859b0c6.png";